/* eslint-disable react/button-has-type */
/* eslint-disable react/require-default-props */
import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { FcNext } from 'react-icons/fc'

type Props = {
  pageNumber: number
  disableNext?: boolean
  disableBack?: boolean
  onNext?: () => void
  onBack?: () => void
}

const Pagination: FC<Props> = ({
  pageNumber,
  disableNext,
  disableBack,
  onBack,
  onNext,
}) => {
  const { t, lang } = useTranslation('client')
  const isArabic = lang === 'ar'
  return (
    <nav
      className="flex items-center justify-between rounded-xl border border-secondary/10 px-4 py-3 sm:px-6"
      aria-label="Pagination"
    >
      <div className="hidden sm:block">
        <p className="text-sm text-gray-700">
          {t('page')} <span className="font-medium">{pageNumber + 1}</span>
        </p>
      </div>
      <div className="flex flex-1 justify-between sm:justify-end">
        {!disableBack && (
          <button
            onClick={() => {
              if (!disableBack && onBack) onBack()
            }}
            className={clsx(
              'relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50',
              {
                'border-0 bg-slate-100 text-gray-400 hover:cursor-not-allowed hover:bg-slate-600':
                  disableBack,
              },
              {
                'rotate-180': !isArabic,
              },
            )}
          >
            <FcNext />
          </button>
        )}
        {!disableNext && (
          <button
            onClick={() => {
              if (!disableNext && onNext) onNext()
            }}
            className={clsx(
              'relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50',
              {
                'border-0 bg-slate-600 text-gray-400 hover:cursor-not-allowed hover:bg-slate-600':
                  disableNext,
              },
              {
                'rotate-180': isArabic,
              },
            )}
          >
            <FcNext />
          </button>
        )}
      </div>
    </nav>
  )
}
export default Pagination
